import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './settings.component';

const routes: Routes = [
  {
    path: '',
    component: SettingsComponent,
    children: [
      {
        path: 'page',
        loadChildren: () => import('./page/page.module').then(m => m.PageModule),
      },
      {
        path: 'service',
        loadChildren: () => import('./service/service.module').then(m => m.ServiceModule),
      },
      {
        path: 'compare-table',
        loadChildren: () => import('./compare-table/compare-table.module').then(m => m.CompareTableModule),
      },
      {
        path: 'menu',
        loadChildren: () => import('./menu-management/menu-management.module').then(m => m.MenuManagementModule),
      },
      {
        path: 'service-agreement',
        loadChildren: () => import('./service-agreement/service-agreement.module').then(m => m.ServiceAgreementModule),
      },
      {
        path: 'third-party-api',
        loadChildren: () => import('./third-party-api/third-party-api.module').then(m => m.ThirdPartyApiModule),
      },
      {
        path: 'lead-message',
        loadChildren: () => import('./lead-message/lead-message.module').then(m => m.LeadMessageModule),
      },
      {
        path: 'email-template',
        loadChildren: () => import('./email-templates/email-templates.module').then(m => m.EmailTemplatesModule),
      },
      {
        path: 'copay-fee',
        loadChildren: () => import('./copay-fee/copay-fee.module').then(m => m.CopayFeeModule),
      },
      {
        path: 'block-contact',
        loadChildren: () => import('./block-contact/block-contact.module').then(m => m.BlockContactModule),
      },
      {
        path: 'checkout-settings',
        loadChildren: () => import('./checkout-settings/checkout-settings.module').then(m => m.CheckoutSettingsModule),
      },
      {
        path: 'global-ip-access',
        loadChildren: () => import('./global-ip-access/global-ip-access.module').then(m => m.GlobalIpAccessModule),
      },
      {
        path: 'page-content',
        loadChildren: () => import('./page-content/page-content.module').then(m => m.PageContentModule),
      },
      {
        path: 'faq',
        loadChildren: () => import('./question-and-answers/question-and-answers.module').then(m => m.QuestionAndAnswersModule),
      },
      {
        path: 'global-email-template',
        loadChildren: () => import('./global-email-templates/global-email-templates.module').then(m => m.GlobalEmailTemplatesModule),
      },
      {
        path: 'status',
        loadChildren: () => import('./status-management/status-management.module').then(m => m.StatusManagementModule),
      },
      {
        path: 'global-lead-partner-popup',
        loadChildren: () => import('./global-lead-partner-popup/global-lead-partner-popup.module').then(m => m.GlobalLeadPartnerPopupModule),
      },
      {
        path: 'loader-content',
        loadChildren: () => import('./loader-content/loader-content.module').then(m => m.LoaderContentModule),
      },
      {
        path: 'global-plan-pricing',
        loadChildren: () => import('./global-plan-pricing/global-plan-pricing.module').then(m => m.GlobalPlanPricingModule),
      },
      {
        path: 'reduce-plan-pricing',
        loadChildren: () => import('./reduce-plan-price/reduce-plan-price.module').then(m => m.ReducePlanPriceModule),
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
